import { SingleValue } from 'react-select';
import useProxyPoolCreationForm from '../../store/proxyPoolCreationFormStore';
import {
  proxyPoolRotationOptions,
  ProxyPoolRotationSchema,
} from '@fd/common/biz/proxyPoolRotationOptions';
import OptionField from '@fd/frontend/components/ProxyPoolCreatePage/OptionFieldCard';
import CustomSelect from '@fd/frontend/components/ui/CustomSelect';

export default function Rotation() {
  return (
    <OptionField.Card>
      <OptionField.Body>
        <OptionField.Title>Session type</OptionField.Title>
        <OptionField.Description>
          To choose how often the IP changes. Rotation times may vary slightly
          but will follow your settings closely.
        </OptionField.Description>
      </OptionField.Body>
      <RotationSelect />
    </OptionField.Card>
  );
}

function RotationSelect() {
  const { rotation, setRotation } = useProxyPoolCreationForm();

  const handleChange = (
    option: SingleValue<{ value: number; label: string }> | null
  ) => {
    try {
      const newRotation = ProxyPoolRotationSchema.parse(option?.value);
      setRotation(newRotation);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <CustomSelect
      value={proxyPoolRotationOptions.filter((o) => o.value === rotation)[0]}
      onChange={handleChange}
      options={proxyPoolRotationOptions}
      placeholder="Select rotation type"
      isSearchable={false}
    />
  );
}
